import { render, staticRenderFns } from "./RecuperarClave.vue?vue&type=template&id=65cf5abb&scoped=true"
import script from "./RecuperarClave.vue?vue&type=script&lang=js"
export * from "./RecuperarClave.vue?vue&type=script&lang=js"
import style0 from "./RecuperarClave.vue?vue&type=style&index=0&id=65cf5abb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cf5abb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65cf5abb')) {
      api.createRecord('65cf5abb', component.options)
    } else {
      api.reload('65cf5abb', component.options)
    }
    module.hot.accept("./RecuperarClave.vue?vue&type=template&id=65cf5abb&scoped=true", function () {
      api.rerender('65cf5abb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/RecuperarClave.vue"
export default component.exports